
const changeSaveDesc = () => {
    console.log('is_notin_target_collection', '3');
    const config = window.checkoutGutBundleConfig || {};

    if (config.isInTargetCollection) {
        const loopPurchaseOptionsDiscountBadge = document.querySelector('.loop-widget-purchase-option-discount-badge');
        let activeDiscountPercent = document.querySelector('.is-active .save .save-sub');
        const loopPurchaseOptionsDescription = document.querySelectorAll('.loop-widget-purchase-option .loop-widget-sp-selector-description');
        
        const loopPurchaseOptions = document.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label');

        if (loopPurchaseOptionsDiscountBadge && loopPurchaseOptionsDiscountBadge.innerHTML.includes('%')) {
            loopPurchaseOptionsDiscountBadge.innerHTML = activeDiscountPercent.innerHTML.includes('%') ? activeDiscountPercent.innerHTML : 'Save 10%';
        }

        loopPurchaseOptionsDescription.forEach(loopPurchaseOptionsDescriptionElement => {
            if(loopPurchaseOptionsDescriptionElement.innerHTML.includes('Save') && loopPurchaseOptionsDescriptionElement.innerHTML.includes('%')) {
                loopPurchaseOptionsDescriptionElement.innerHTML = loopPurchaseOptionsDescriptionElement.innerHTML.replace(/Save \d+%/, activeDiscountPercent.innerHTML);
            } 
        });
    }
}

const getProductId = () => {
    const selectedFlavor = document.querySelector('input[name="option-flavor"]:checked').value;
    if(!selectedFlavor){
        return 42821677777009;
    }
    return selectedFlavor;
};

document.addEventListener('DOMContentLoaded', function() {
    // Swiper logic removed as part of theme slider replacement

    const flavorOptions = document.querySelectorAll('.purchase-option input[type="radio"]');
    flavorOptions.forEach(option => {
        option.addEventListener('change', function() {
            if (this.checked) {
                const selectedFlavor = this.getAttribute('data-flavor');
                // Target Splide slides generated by media-gallery
                // We assume the first slide is the first image, second slide is the second image
                const slides = document.querySelectorAll('.product__media .x-splide-slide');
                
                // Ensure we have slides before proceeding
                if (!slides || slides.length === 0) return;

                const firstSlideImgs = slides[0] ? slides[0].querySelectorAll('img') : [];
                const secondSlideImgs = slides[1] ? slides[1].querySelectorAll('img') : [];
                
                const purchaseBenefitsListAssortedFlavs = document.querySelector('#assorted-flavs');

                let newSrc = '//drkellyann.com/cdn/shop/files/gutharmonybundle-cc.png?v=1764872196';
                let newSrcset = `${newSrc}&width=352 352w, 
                                 ${newSrc}?v=1764872196&width=832 832w, 
                                 ${newSrc}?v=1764872196&width=1200 1200w, 
                                 ${newSrc}?v=1764872196&width=1500 1500w`;
                let newSrc1 = '//drkellyann.com/cdn/shop/files/Bone_Broth_-_Classic_Chicken_-1b.jpg?v=1765911197';
                let newSrcset1 = `${newSrc1}&width=352 352w, 
                                 ${newSrc1}?v=1764872196&width=832 832w, 
                                 ${newSrc1}?v=1764872196&width=1200 1200w, 
                                 ${newSrc1}?v=1764872196&width=1500 1500w`;

                if(selectedFlavor === 'cc') {
                  // Keep Defaults
                  if(purchaseBenefitsListAssortedFlavs) purchaseBenefitsListAssortedFlavs.style.visibility = 'hidden';
                } else if(selectedFlavor === 'beef') {
                    newSrc = '//drkellyann.com/cdn/shop/files/gutharmonybundle-beef.png?v=1764792708';
                    newSrcset = `${newSrc}&width=352 352w, ${newSrc}?v=1764872196&width=832 832w, ${newSrc}?v=1764872196&width=1200 1200w, ${newSrc}?v=1764872196&width=1500 1500w`;
                    newSrc1 = '//drkellyann.com/cdn/shop/files/Bone_Broth_-_Classic_Beef_-1b.jpg?v=1765911197';
                    newSrcset1 = `${newSrc1}&width=352 352w, ${newSrc1}?v=1764872196&width=832 832w, ${newSrc1}?v=1764872196&width=1200 1200w, ${newSrc1}?v=1764872196&width=1500 1500w`;
                    if(purchaseBenefitsListAssortedFlavs) purchaseBenefitsListAssortedFlavs.style.visibility = 'hidden';
                } else if(selectedFlavor === 'assorted') {
                    newSrc = '//drkellyann.com/cdn/shop/files/gutharmonybundle-assorted.png?v=1764792708';
                    newSrcset = `${newSrc}&width=352 352w, ${newSrc}?v=1764872196&width=832 832w, ${newSrc}?v=1764872196&width=1200 1200w, ${newSrc}?v=1764872196&width=1500 1500w`;
                    newSrc1 = '//drkellyann.com/cdn/shop/files/Bone_Broth_-_Classic_Beef_-1b.jpg?v=1765911197';
                    newSrcset1 = `${newSrc1}&width=352 352w, ${newSrc1}?v=1764872196&width=832 832w, ${newSrc1}?v=1764872196&width=1200 1200w, ${newSrc1}?v=1764872196&width=1500 1500w`;
                    if(purchaseBenefitsListAssortedFlavs) purchaseBenefitsListAssortedFlavs.style.visibility = 'visible';
                }

                // Update images
                firstSlideImgs.forEach(img => {
                    img.setAttribute('srcset', newSrcset);
                    img.setAttribute('src', newSrc);
                    // Also update hidden preloaded image if it exists
                    const parent = img.closest('.x-splide-slide');
                    if(parent && parent.classList.contains('active')) {
                        // force redraw if needed, but src change should suffice
                    }
                });
                secondSlideImgs.forEach(img => {
                    img.setAttribute('src', newSrc1);
                    img.setAttribute('srcset', newSrcset1);
                });
            }
        });
    });

    document.querySelectorAll('input[name="purchase-option"]').forEach((radio) => {
        radio.addEventListener('change', (event) => {
            const selectedOption = event.target.id;
            document.querySelectorAll('.loop-widget-purchase-option').forEach((option) => {
                option.classList.remove('loop-widget-purchase-option-selected');
            });
            if (selectedOption === 'onetime-purchase-radio') {
                document.querySelector('.loop-widget-purchase-option-onetime').classList.add('loop-widget-purchase-option-selected');
            } else if (selectedOption === 'subscribe-save-radio') {
                document.querySelector('#loop-widget-purchase-option-id-091440bb412697c5c97504cf99d91f4cfaf82095').classList.add('loop-widget-purchase-option-selected');
            }
        });
    });

    // Set the countdown time (15 minutes from now)
    var countdownTime = new Date().getTime() + 30 * 60 * 1000;

    // Update the countdown every second
    var countdownInterval = setInterval(function() {
        var now = new Date().getTime();
        var distance = countdownTime - now;

        // Calculate minutes and seconds
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result
        const minutesEl = document.querySelector('.countdown-timer .minutes');
        const secondsEl = document.querySelector('.countdown-timer .seconds');
        
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

        // If the countdown is over, clear the interval
        if (distance <= 0) {
            clearInterval(countdownInterval);
            if (minutesEl) minutesEl.textContent = "00";
            if (secondsEl) secondsEl.textContent = "00";
        }
    }, 1000);
});

document.addEventListener('DOMContentLoaded', function() {
    const config = window.checkoutGutBundleConfig || {};

    document.querySelectorAll('.save-var1').forEach(el => el.style.display = 'none');

    setTimeout(() => {
        changeSaveDesc();
    }, 1500);

    const loopContainer = document.querySelector(".loop-widget-container");
    if (loopContainer) {
        loopContainer.addEventListener('click', function(event) {
            const loopPurchaseOptions = document.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label');
            const saveFlatSpans = document.querySelectorAll('.save .save-flat');
            const saveSubSpans = document.querySelectorAll('.save .save-sub');

            if (loopPurchaseOptions && loopPurchaseOptions.innerHTML === 'One-time purchase' ){
                document.querySelectorAll('.sizeselector-flatprice').forEach(el => el.style.display = 'block');
                document.querySelectorAll('.sizeselector-subprice').forEach(el => el.style.display = 'none');
                document.querySelectorAll('.save-var1').forEach(el => el.style.display = 'none');
                saveFlatSpans.forEach(el => el.style.display = 'block');
                saveSubSpans.forEach(el => el.style.display = 'none');
                document.querySelectorAll('.newpricetagtest').forEach(el => el.style.display = 'none');
            }
            else {
                document.querySelectorAll('.sizeselector-flatprice').forEach(el => el.style.display = 'none');
                document.querySelectorAll('.sizeselector-subprice').forEach(el => el.style.display = 'block');
                saveFlatSpans.forEach(el => el.style.display = 'none');
                saveSubSpans.forEach(el => el.style.display = 'block');
                document.querySelectorAll('.save-var1').forEach(el => el.style.display = 'block');
                document.querySelectorAll('.newpricetagtest').forEach(el => el.style.display = 'block');
            }

            changeSaveDesc();
        }); 
    }

    const selectButton = document.querySelector(".custom-selectbutton");
    if (selectButton) {
        selectButton.addEventListener('click', function(event) {
            const loopPurchaseOptions = document.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label');
            const activeSubprice = document.querySelector('.is-active .sizeselector-subprice');

            const priceHiddentFlatprice = document.querySelector('.is-active .pricehidden-flatprice');
            const priceHiddentSubprice = document.querySelector('.is-active .pricehidden-subprice');
            console.log('priceHiddentFlatprice', priceHiddentFlatprice);
            console.log('priceHiddentSubprice', priceHiddentSubprice);
            const loopWidgetSubsPrice = document.querySelector('.loop-widget-purchase-option-subscription .loop-widget-purchase-option-price');
            const loopWidgetOneTimePrice = document.querySelector('.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price');

            if (priceHiddentFlatprice && priceHiddentSubprice) {
                if (loopWidgetSubsPrice) loopWidgetSubsPrice.innerHTML = priceHiddentSubprice.value;
                if (loopWidgetOneTimePrice) loopWidgetOneTimePrice.innerHTML = priceHiddentFlatprice.value;
            }


            if (loopPurchaseOptions && loopPurchaseOptions.innerHTML != 'One-time purchase' ){
                changeSaveDesc();
            }

            if (config.isSherriPage) {
                const selectedBroth = document.querySelector('.selected-broth');
                if (selectedBroth) {
                    const selectedProduct = selectedBroth.getAttribute('data-size-based-image');
                    if (selectedProduct == "true" && activeSubprice) {
                        const dataValue = activeSubprice.getAttribute('data-id');
                        const swiperEl = document.querySelector('.product__media-inner .swiper');
                        if (swiperEl && swiperEl.swiper) {
                             swiperEl.swiper.slideTo(dataValue - 1, 0, false);
                        } else {
                            console.warn('Swiper element not found - slide functionality disabled');
                        }
                    }
                }
            }
        });
    }

    const modal = document.getElementById('ingredientsModal');
    if (modal) {
        const modalImg = modal.querySelector('.modal-img');
        const modalCloseButton = modal.querySelector('.btn-close');
        const modalOverlay = modal.querySelector('.modal-dialog');

        document.querySelectorAll('.modalTrigger').forEach(button => {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                const imgSrc = this.getAttribute('data-bs-target');
                if (imgSrc) {
                    modalImg.src = imgSrc;
                }
                modal.classList.add('show');
                modal.style.display = 'block';
            });
        });

        const closeModal = () => {
            modal.classList.remove('show');
            modal.style.display = 'none';
            modalImg.src = '';
        };

        if (modalCloseButton) modalCloseButton.addEventListener('click', closeModal);
        modal.addEventListener('click', function (event) {
            if (modalOverlay && !modalOverlay.contains(event.target)) {
                closeModal();
            }
        });
    }

    const priceHiddentFlatprice = document.querySelector('.is-active .pricehidden-flatprice');
    const priceHiddentSubprice = document.querySelector('.is-active .pricehidden-subprice');
    const loopWidgetSubsPrice = document.querySelector('.loop-widget-purchase-option-subscription .loop-widget-purchase-option-price');
    const loopWidgetOneTimePrice = document.querySelector('.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price');
    if (priceHiddentFlatprice && priceHiddentSubprice) {
        if (loopWidgetSubsPrice) loopWidgetSubsPrice.innerHTML = priceHiddentSubprice.value;
        if (loopWidgetOneTimePrice) loopWidgetOneTimePrice.innerHTML = priceHiddentFlatprice.value;
    }

    if (config.defaultValue) {
        const spanWrap = document.querySelector(`.span-wrap[data-value='${config.defaultValue}']`);
        if (spanWrap) spanWrap.click();
    }

    document.querySelectorAll(".static-cta button, button.scroll").forEach(button => {
        button.addEventListener('click', () => {
            const productForm = document.querySelector('.options-bracket');
            if (productForm) {
                const scrollDistance = productForm.offsetTop;
                window.scrollTo({
                    top: scrollDistance,
                    behavior: 'smooth'
                });
            }
        });
    });

    const product__submit = document.querySelectorAll('.submit');
    if (product__submit) {
        product__submit.forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                const config = window.checkoutGutBundleConfig || {};
                let productId = getProductId(); 
                const suffix = config.checkoutUrlSuffix || '%2Fcheckout';
                window.location.href = `https://drkellyann.com/cart/clear?return_to=%2Fcart%2Fadd%3Fitems%5B0%5D%5Bid%5D%3D${productId}%26items%5B0%5D%5Bquantity%5D%3D1%26return_to%3D${suffix}`;
            });
        });
    }

    const subsubmit = document.querySelectorAll('.subsubmit');
    if (subsubmit) {
        subsubmit.forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                let productId = getProductId(); 
                window.location.href = `https://drkellyann.com/cart/clear?return_to=%2Fcart%2Fadd%3Fitems%5B0%5D%5Bid%5D%3D${productId}%26items%5B0%5D%5Bquantity%5D%3D1%26items%5B0%5D%5Bselling_plan%5D%3D2122481777%26return_to%3D%2Fcheckout%3Fdiscount%3DGUTSUBUNDL100`;
            });
        });
    }
});

// Custom Slider Controls Logic
(function () {

  function initCustomSliderControls() {
    // 🔒 Prevent parallel runs
    if (window.__gutSliderRunning) return;
    window.__gutSliderRunning = true;

    const container = document.querySelector('.custom-gallery-container_gut_bundle');

    if (!container) {
      window.__gutSliderRunning = false;
      return;
    }

    const prevBtn = container.querySelector('.custom-gut-prev');
    const nextBtn = container.querySelector('.custom-gut-next');
    const dotsContainer = container.querySelector('.custom-gut-pagination');

    let attempts = 0;
    const maxAttempts = 60; // ⬆️ iOS mate thodu vadhare wait

    const checkSplide = setInterval(() => {
      attempts++;

      const splideEl = container.querySelector('.x-splide');

      if (
        splideEl &&
        splideEl.splide &&
        typeof splideEl.splide.go === 'function'
      ) {
        clearInterval(checkSplide);
        window.__gutSliderRunning = false;

        const splide = splideEl.splide;

        /* ---------- ARROWS ---------- */
        if (prevBtn) {
          const btn = prevBtn.cloneNode(true);
          prevBtn.replaceWith(btn);
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            splide.go('<');
          });
        }

        if (nextBtn) {
          const btn = nextBtn.cloneNode(true);
          nextBtn.replaceWith(btn);
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            splide.go('>');
          });
        }

        /* ---------- DOTS ---------- */
        const updateDots = () => {
          if (!dotsContainer) return;

          dotsContainer.innerHTML = '';
          for (let i = 0; i < splide.length; i++) {
            const dot = document.createElement('div');
            dot.className = 'custom-gut-dot';
            if (i === splide.index) dot.classList.add('active');

            dot.addEventListener('click', () => splide.go(i));
            dotsContainer.appendChild(dot);
          }
        };

        updateDots();

        splide.on('move', (index) => {
          dotsContainer?.querySelectorAll('.custom-gut-dot')
            .forEach((d, i) => d.classList.toggle('active', i === index));
        });

        splide.on('refresh', updateDots);
      }

      if (attempts >= maxAttempts) {
        clearInterval(checkSplide);
        window.__gutSliderRunning = false;
      }
    }, 200);
  }

  /* ===============================
     INIT HOOKS (IMPORTANT FOR iOS)
     =============================== */

  document.addEventListener('DOMContentLoaded', initCustomSliderControls);

  // 🔹 iOS needs this
  window.addEventListener('load', initCustomSliderControls);

  // 🔹 Safari bfcache fix (MOST IMPORTANT)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setTimeout(initCustomSliderControls, 300);
    }
  });

})();

